// extracted by mini-css-extract-plugin
export var btn = "Button-module--btn--3bdcb";
export var light = "Button-module--light--7b73f";
export var outline = "Button-module--outline--fb424";
export var shadowed = "Button-module--shadowed--06c53";
export var small = "Button-module--small--3227d";